module.exports = __webpack_public_path__ + "img/003-wallet.d311d951.svg";